import { render } from "./OverdueNotif.vue?vue&type=template&id=b46d0f64&scoped=true"
import script from "./OverdueNotif.vue?vue&type=script&lang=js"
export * from "./OverdueNotif.vue?vue&type=script&lang=js"

import "./OverdueNotif.vue?vue&type=style&index=0&id=b46d0f64&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b46d0f64"]])

export default __exports__